export default {
    id: 'yellow',
    colors: ['#944710', '#FFE366'],
};
